import { Component, OnInit } from '@angular/core';
import { Router, NavigationExtras,ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-patsignup',
  templateUrl: './patsignup.component.html',
  styleUrls: ['./patsignup.component.css']
})
export class PatsignupComponent implements OnInit {
  recievemessage:any;
  istrue = false;
  constructor(private route:ActivatedRoute,private router:Router) {const navigation = this.router.getCurrentNavigation();
    this.recievemessage = this.router.getCurrentNavigation().extras.state as {
      message: string,
    }; ; }

  ngOnInit(): void {
  console.log(this.recievemessage,"this is recievemessage");
  if(this.recievemessage){
    this.istrue = true;
  }
  }
 

}
